import React, { Component } from "react";
import Header from "../components/header";
import FooterDark from "../components/footer/footer_dark"
import Body from "../components/resultpage/body_result"
import Section2Banner from "../components/section2-banner/section2";

class ResultPage extends Component{
    render(){
        return(
            <div>
                <Header />
                <Body />
                <Section2Banner />
                <FooterDark />
            </div>
        )
    }
}

export default ResultPage;